/* eslint-disable camelcase */
import { Order } from '../../models';
import {
  GET_ORDER,
  GET_ORDER_PAYMENT_STATUS,
  RESET_ORDER,
  RESET_ORDER_PAYMENT_STATUS,
} from '../constants/order';

export const getOrder = (data) => {
  const { order } = data;
  if (!order) {
    return (dispatch) => {
      dispatch({ type: RESET_ORDER });
    };
  }

  const convertedOrder = new Order(
    order?.id,
    order?.status,
    order?.currency,
    order?.total,
    order?.fee,
    order?.total_with_fee,
  );

  return (dispatch) => {
    dispatch({
      type: GET_ORDER,
      ...convertedOrder,
    });
  };
};

export const getOrderPaymentStatus = (data) => {
  const { status } = data;
  if (!status) {
    return (dispatch) => {
      dispatch({ type: RESET_ORDER_PAYMENT_STATUS });
    };
  }

  return (dispatch) => {
    dispatch({
      type: GET_ORDER_PAYMENT_STATUS,
      status: status ?? null,
    });
  };
};
